<div class="youtube-source-preview-dialog-container">
	<div class="d-flex justify-content-between align-items-center">
		<span class="title" mat-dialog-title>{{ 'SETTINGS.YOUTUBE_SOURCE.PREVIEW.TITLE_DIALOG' | translate }} — {{ data.source.name }}</span>
		<button mat-icon-button (click)="close()" class="d-flex justify-content-center align-items-center me-4">
			<mat-icon>close</mat-icon>
		</button>
	</div>

	<mat-dialog-content class="m-0 p-3">
		<p class="source-url">{{ data.source.url }}</p>

		@if (loading) {
		<div class="loading-container">
			<mat-spinner></mat-spinner>
		</div>
		} @else {
		@if (dataSource.data.length === 0) {
		<div class="preview-empty">
			<mat-icon>visibility</mat-icon>
			<span>{{ 'SETTINGS.YOUTUBE_SOURCE.PREVIEW.EMPTY' | translate }}</span>
		</div>
		} @else {
		@if (shownCount < totalMatching) {
		<p class="truncated-note">{{ 'SETTINGS.YOUTUBE_SOURCE.PREVIEW.SHOWING' | translate: { shown: shownCount, total: totalMatching } }}</p>
		}
		<div class="mat-elevation-z2 px-0">
			<table mat-table [dataSource]="dataSource" class="preview-table">
				@for (column of displayedColumns; track $index) {
				<ng-container [matColumnDef]="column">
					<th mat-header-cell *matHeaderCellDef>
						{{ 'SETTINGS.YOUTUBE_SOURCE.PREVIEW.' + column | translate }}
					</th>
					<td mat-cell *matCellDef="let element">
						@switch (column) {
						@case ('TITLE') {
						<a [href]="element.url" target="_blank" rel="noopener">{{ element.title }}</a>
						}
						@case ('DATE') {
						{{ element.publicationDate ? (element.publicationDate | date: 'dd.MM.yyyy') : '—' }}
						}
						@case ('SUBTITLES') {
						{{ element.subtitleKind ? ('SETTINGS.YOUTUBE_SOURCE.PREVIEW.SUBTITLE_KIND.' + element.subtitleKind | translate) : '—' }}
						}
						@case ('STATUS') {
						<span class="status-badge" [class]="'status-' + element.status.toLowerCase()">
							{{ 'SETTINGS.YOUTUBE_SOURCE.PREVIEW.STATUS_LABEL.' + element.status | translate }}
						</span>
						@if (element.status === 'ERROR' && element.errorMessage) {
						<div class="error-reason">{{ element.errorMessage }}</div>
						}
						}
						}
					</td>
				</ng-container>
				}
				<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
				<tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
			</table>
		</div>
		}
		}
	</mat-dialog-content>

	<mat-dialog-actions [align]="'end'" class="pe-4">
		<button mat-flat-button type="button" color="primary" (click)="close()">
			{{ 'BUTTON.CLOSE' | translate }}
		</button>
	</mat-dialog-actions>
</div>
